import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../contact-us/contact-us.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-eastvale-en',
  templateUrl: './eastvale-en.component.html',
  styleUrls: ['./eastvale-en.component.scss'],
  standalone: false
})
export class EastvaleEnComponent implements OnInit {
  play = true;
  updateForm: UntypedFormGroup;
  submitted: boolean;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    items: 1,
    pullDrag: false,
    autoplay: true,
    autoplayTimeout: 3500,
    autoplaySpeed: 1000,
    dots: true,
    navSpeed: 700,
    navText: ['Previous', 'Next'],
    nav: false
  };
  slidesStore = [
    {
      src: '../../assets/images/eastvale1.png',
      id: '1'
    },
    {
      src: '../../assets/images/eastvale2.png',
      id: '2'
    },
    {
      src: '../../assets/images/eastvale3.png',
      id: '3'
    },
  ];
  videOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    items: 1,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    center: true,
    startPosition: 1,
    navText: ['Previous', 'Next'],
    nav: true
  };

  ngOnInit(): void {
    this.initForm();
  }

  constructor(
    private builder: UntypedFormBuilder,
    private contactService: ContactUsService) {
  }

  initForm(): void {
    this.updateForm = this.builder.group(
      {
        phone: ['', Validators.required],
        name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        notes: ['', [Validators.required, Validators.minLength(20)]]
      },
      onblur
    );
  }

  isFieldValid(field: string): boolean {
    return (
      !this.updateForm.get(field).valid && this.updateForm.get(field).touched
    );
  }

  onSubmit(): void {
    if (this.updateForm.valid) {
      this.submitted = true;
      const popup = {
        title: 'Your inquiry has been sent successfully',
        text: 'We will contact you as soon as possible',
        button: 'Done',
      };

      this.contactService.sendMail(this.updateForm.value).subscribe(
        (res) => {
          Swal.fire({
            title: popup.title,
            text: popup.text,
            icon: 'success',
            confirmButtonText: popup.button,
          }).then(() => {
            this.submitted = false;
            this.updateForm.reset();
          });
        },
        (err) => {
          console.log(err);
          this.submitted = false;
        }
      );
    }
  }

  // tslint:disable-next-line:typedef
  playPause() {
    const video = document.querySelector('#video') as HTMLVideoElement;
    this.play = !this.play;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  scrollTo(el: HTMLElement): void {
    el.scrollIntoView({ behavior: 'smooth' });
    console.log(el);
  }
}
